// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Id53RanNGp9aNZEcAYRqm {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 20;\n}\n\n.PXA2vMHpk9G57f-igiJgq {\n    display: flex;\n    flex-direction: row;\n}\n\n._1His2S00vNzfyMYg_9ukDG {\n    line-height: 36px;\n    font-size: 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "Id53RanNGp9aNZEcAYRqm",
	"wrapper": "PXA2vMHpk9G57f-igiJgq",
	"sortCriteria": "_1His2S00vNzfyMYg_9ukDG"
};
module.exports = exports;
